export const ASSET_POLL_INTERVAL_MS = 3000;
